import { cls } from "@wss/cls";
import React from "react";
import Icon from "~/common/Icons/Standard";
interface Props {
  addUserUpvote: (reviewId: number, upvoted: boolean) => void;
  userVoted: boolean;
  userUpvoted: boolean;
  reviewId: number;
}
const HelpfulReviewButtons = ({
  addUserUpvote,
  userUpvoted,
  userVoted,
  reviewId
}: Props) => {
  const handleUpdateHelpfulReview = (event: React.SyntheticEvent, reviewId: number, isHelpful: boolean) => {
    event.preventDefault();
    addUserUpvote(reviewId, isHelpful);
  };
  return <div aria-live="polite" className="product-review__was-this-helpful text-sm leading-4 m-0" data-testid="was-this-review-helpful" data-sentry-component="HelpfulReviewButtons" data-sentry-source-file="HelpfulReviewButtons.tsx">
      {userVoted ? <>
          <p className="inline-block m-0">
            {`You ${userUpvoted ? "found" : "did not find"} this review helpful`}
          </p>
          <span className={cls(userUpvoted ? "bg-green-600" : "bg-red-400", "p-2", "ml-2", "h-4", "w-4", "align-middle", "rounded-sm", "inline-block")}>
            <span className="text-neutral-100">
              {userUpvoted ? <Icon name="thumb-up-fill" className="h-4 w-4" data-testid="thumb-up-voted" /> : <Icon name="thumb-down-fill" className="h-4 w-4" data-testid="thumb-down-voted" />}
              <span className="sr-only" data-testid="sr-review-feedback">
                {`You ${userUpvoted ? "found" : "did not find"} this review helpful`}
              </span>
            </span>
          </span>
        </> : <>
          <p className="inline-block m-0 mr-2">Was this review helpful?</p>
          <span className="inline-block mt-2">
            <button type="button" aria-label="yes this review was helpful" className="icon-thumb-up-fill p-2 h-8 w-8 bg-gray-50 text-green-600 border-none rounded-sm align-middle hover:text-green-800" data-testid="update-helpful-review-upvote" onClick={event => handleUpdateHelpfulReview(event, reviewId, true)}>
              <Icon name="thumb-up-fill" className="h-4 w-4" />
            </button>
            <button type="button" aria-label="no this review was not helpful" className="icon-thumb-down-fill p-2 h-8 w-8 ml-2 bg-gray-50 text-red-400 border-none rounded-sm align-middle hover:text-red-900" data-testid="update-helpful-review-downvote" onClick={event => handleUpdateHelpfulReview(event, reviewId, false)}>
              <Icon name="thumb-down-fill" className="h-4 w-4" />
            </button>
          </span>
        </>}
    </div>;
};
export default HelpfulReviewButtons;